import { SortOrder } from "../sort-order";

export class EventFilters {
  name: string;
  active: boolean;
  entityType: string;
  serialNumber: string;
  alias: string;
  tenantUuids: string[];
  sortField: string;
  sortOrder: SortOrder;
}
